import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {

  @Input() simpleCardForm: boolean = false;
  @Input() simpleCardLabel: string = "Form";
  @Input() dateValue?: Date;
  @Input() canClear: boolean = true;

  @Output() onDateChangeEvent: EventEmitter<Date> = new EventEmitter<Date>();

  loading = false;
  newDateValue?: string; // Changed to string for HTML5 date input

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    // Convert Date to YYYY-MM-DD string format
    if (this.dateValue != null) {
      this.newDateValue = new Date(this.dateValue).toISOString().split('T')[0];
    }
  }

  onDateChange(event?: any) {
    if (event) {
      this.newDateValue = event.target.value;
    }
    
    // Emit Date object if using as embedded component
    if (this.simpleCardForm && this.newDateValue) {
      const date = new Date(this.newDateValue);
      this.onDateChangeEvent.emit(date);
    }
  }

  saveKeyDate() {
    // Convert string back to Date object for modal return
    const date = this.newDateValue ? new Date(this.newDateValue) : null;
    this.activeModal.close({ date: date });
  }

  cancel() {
    this.activeModal.dismiss();
  }

  clearDate() {
    this.activeModal.close({ date: null });
  }
}